import * as React from "react";

export const Header = () => (
    <>
        <path
            d="M3.375 4L3.375 12M7.875 8L3.58112 8M8.375 4L8.375 12"
            stroke="currentColor"
            fill="none"
            strokeWidth="1.2"
            strokeLinecap="round"
        />
        <path
            d="M13.0117 11.9985L13.0117 6.69705C13.0117 6.53366 12.8264 6.43921 12.6942 6.5352L11.375 7.49298"
            stroke="currentColor"
            fill="none"
            strokeWidth="1.2"
            strokeLinecap="round"
        />
    </>
);
